import $ from 'jquery'

export default {
    name: 'ajout-stock',
    components: {},
    props: [],
    data () {
        return {
            loading: false,
            stock: {
                'nom': '',
                'description': '',
                'utilisateur': '',
            }
        }
    },
    computed: {
        users() {
            return this.$store.getters['users']
        },
    },
    mounted () {
        setTimeout(() => {
            $('.p-content').fadeIn();
        }, 500);

        this.$store.dispatch("getUsers");

    },
    methods: {
        async submitForm() {

            const isValid = await this.$refs.observer.validate();
            if (!isValid) {
                console.log('error')
            } else {
                this.loading=true;

                const data = this.stock  
                this.$store.dispatch("saveStock",data).then(
                    response => {
                        if (response) {
                            this.$router.push({ path: `/stock` }) 
                            this.loading=false;
                        } 
                    }
                );
            }
    
        },
    }
}


